export { default as NowShowing } from "./NowShowing";
export { default as MovieList } from "./MovieList";
export { default as NextReleaseUpcoming } from "./NextReleaseUpcoming";
export { default as NowShowingUpcoming } from "./NowShowingUpcoming";
export { default as NowShowingWithGalleryAndList } from "./NowShowingWithGalleryAndList";
